import { useEffect, useRef, useState } from "react";

/** Wartezeit nach dem letzten Tastendruck, bevor eine Suche an den Server geht (Kundenliste, Artikelbereich). */
export const SUCH_VERZOEGERUNG_MS = 250;

/**
 * Die VERZÖGERTE SUCHE eines Suchfelds — herausgelöst aus der Kundenliste, damit Kundenliste und Artikelbereich
 * denselben Weg gehen: Das Feld zeigt jede Eingabe sofort (`eingabe`), gemeldet wird sie erst, wenn
 * `SUCH_VERZOEGERUNG_MS` lang nichts mehr getippt wurde. Drei Tastendrücke sind EIN Abruf.
 *
 * Ändert sich der gemeldete Wert von außen (zurückgesetzt), zieht das Feld nach — nur bei einer Änderung, nicht beim
 * Einhängen (ME-Etappe 2, Fixrunde F2): Der Effekt ist passiv und liefe sonst nach einem Zeichnen außerhalb von `act`
 * erst nach dem Malen, und ein Tastendruck in dieser Lücke ginge verloren (web/test/listenspalte.test.tsx).
 */
export function useVerzoegerteSuche(wert: string, onSuche: (text: string) => void): [string, (text: string) => void] {
  const [eingabe, setEingabe] = useState(wert);
  const letztGemeldet = useRef(wert);
  const gesehen = useRef(wert);
  useEffect(() => {
    if (wert === gesehen.current) return;
    gesehen.current = wert;
    setEingabe(wert);
    letztGemeldet.current = wert;
  }, [wert]);

  // Der Melder über eine Ref: Ein neuer Funktionswert bei jedem Elternrender darf den laufenden Timer nicht neu starten.
  const melden = useRef(onSuche);
  melden.current = onSuche;
  useEffect(() => {
    if (eingabe === letztGemeldet.current) return undefined;
    const timer = setTimeout(() => {
      letztGemeldet.current = eingabe;
      melden.current(eingabe);
    }, SUCH_VERZOEGERUNG_MS);
    return () => clearTimeout(timer);
  }, [eingabe]);

  return [eingabe, setEingabe];
}
